import { render, staticRenderFns } from "./AffiliateCommissionTiers.vue?vue&type=template&id=09f692e0&scoped=true&"
import script from "./AffiliateCommissionTiers.vue?vue&type=script&lang=js&"
export * from "./AffiliateCommissionTiers.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCommissionTiers.vue?vue&type=style&index=0&id=09f692e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f692e0",
  null
  
)

export default component.exports